import ReactGA from 'react-ga';

class Analytics {    
    async event(event) {
        try {
            ReactGA.event(event);
        } catch(e) {}
    }

    async report(error, fatal = false) {
        try {
            ReactGA.exception({
              description: error.message || error,
              fatal
            })
        } catch(e) {}
    }
}

export default new Analytics();